import React, { useEffect, useState } from 'react';
import { Button } from 'tea-component';
// import styles from './styles/index.less';
import aigcIcon from './styles/aigc.svg';
import Dialog from './components/dialog';
import { useIntl } from 'umi';
import './styles/index.scss';
import { buriedBtnPoint } from '../../operationLog/buriedPoint';
import BubbleCommon, { commonGPTDisableTips } from '../BubbleCommon';
export default function AICG({
  style,
  event: { handleAigcConfirm = () => {} },
  defaultValue = 0,
  params,
  showBtn = true,
  showDialog,
  setShowDialog,
  showTips = false,
  topic,
  showAigcWithoutDialog = false,
  setShowAigcWithoutDialog,
}: {
  style?: React.CSSProperties;
  event: {
    handleAigcConfirm?: any;
  };
  defaultValue: number;
  params?: any;
  showBtn?: boolean;
  showDialog?: boolean;
  setShowDialog?: any;
  showTips?: boolean;
  topic?: string;
  showAigcWithoutDialog?: boolean;
  setShowAigcWithoutDialog?: (value: boolean) => void;
}) {
  const total = defaultValue || 0;

  const [dialogVisible, setDialogVisible] = useState(false);
  const { formatMessage } = useIntl();

  const handleBtnClick = () => {
    buriedBtnPoint('GPT_Get_Btn');
    setDialogVisible(true);
  };

  useEffect(() => {
    if (showDialog) {
      setDialogVisible(showDialog);
    }
  }, [showDialog]);

  if (!showBtn) return null;

  return (
    <>
      <Dialog
        value={dialogVisible}
        setValue={(value) => {
          setDialogVisible(value);
          setShowDialog?.(value);
        }}
        topic={topic}
        handleAigcConfirm={handleAigcConfirm}
        params={params}
        showAigcWithoutDialog={showAigcWithoutDialog}
        setShowAigcWithoutDialog={setShowAigcWithoutDialog}
      ></Dialog>
      <div className="dbo-aigc-wrapper" style={style}>
        <BubbleCommon
          showIcon={false}
          placement="top"
          childStyle={{ width: '100%' }}
          tipsMap={showTips && total === 0 ? commonGPTDisableTips : undefined}
        >
          <Button
            type="primary"
            className="dbo-aigc-btn"
            disabled={total === 0}
            onClick={() => handleBtnClick()}
          >
            <img
              src={aigcIcon}
              className="dbo-aigc-icon"
              style={{
                marginRight: 4,
              }}
            />
            {formatMessage({ id: 'Get GPT Summary' })}
          </Button>
        </BubbleCommon>
      </div>
    </>
  );
}
